"use client";

import type { AuthTab } from "@casino/ui/Games/hooks/useAuthGate";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
} from "@workspace/frontend-ui";
import type { FC } from "react";
import ProfileForm from "./ProfileForm";

type Props = {
  open?: boolean;
  onOpenChange: (isVisible: boolean) => void;
  authTab: AuthTab;
  onSuccess: () => void;
  dialogTitle: string;
  dialogDescription: string;
};

// Padding belongs on this stationary wrapper — on ProfileForm's scrolling element it would scroll away.
const MobileAuthDrawer: FC<Props> = ({
  open,
  onOpenChange,
  authTab,
  onSuccess,
  dialogTitle,
  dialogDescription,
}) => (
  <Drawer open={open} onOpenChange={onOpenChange} repositionInputs={false}>
    <DrawerContent>
      <DrawerTitle className="sr-only">{dialogTitle}</DrawerTitle>
      <DrawerDescription className="sr-only">
        {dialogDescription}
      </DrawerDescription>
      <div className="p-4">
        <ProfileForm defaultTab={authTab} onSuccess={onSuccess} />
      </div>
    </DrawerContent>
  </Drawer>
);

export default MobileAuthDrawer;
